export default "__VITE_ASSET__a78cedd2__"